module.exports = __webpack_public_path__ + "6a0115026433820e2b5d9cdbecc66a56.jpg";